module.exports = __webpack_public_path__ + "static/media/sleb-normal.1c4095dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/aliens/sleb-normal.png
// module id = 287
// module chunks = 0